<div *ngIf="previewData">
    <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
    <div>
         <strong>Title:&nbsp;</strong> <span class="fw-semibold">{{previewData.TrainingSchedulesData[0].title}}</span>
    </div>
    <!-- <div *ngIf="previewData.course">
        <strong>Course:&nbsp;</strong> <span class="fw-semibold">{{previewData.course.name || previewData.course.code}}</span>
    </div>
    <div *ngIf="previewData.participants && previewData.participants.length">
        <strong>Participants:&nbsp;</strong>
        <span class="fw-semibold">
            <ng-container *ngFor="let p of previewData.participants; let last = last">
                {{p}}{{!last ? ', ' : ''}}
            </ng-container>
        </span>
    </div>
    <div *ngIf="previewData.trainers && previewData.trainers.length">
        <strong>Trainers:&nbsp;</strong>
        <span class="fw-semibold">
            <ng-container *ngFor="let t of previewData.trainers; let last = last">
                {{t.name}}{{!last ? ', ' : ''}}
            </ng-container>
        </span>
    </div>
    <div *ngIf="previewData.trainersRemarks">
        <strong>Trainer's Remarks:&nbsp;</strong> <span class="fw-semibold">{{previewData.trainersRemarks}}</span>
    </div>
    <div *ngIf="previewData.trainingDetail">
        <strong>Training Detail:&nbsp;</strong> <span class="fw-semibold">{{previewData.trainingDetail}}</span>
    </div>
    <div *ngIf="previewData.dateRanges && previewData.dateRanges.length">
        <strong>Schedule(s):</strong>
        <ul class="mb-1">
            <li *ngFor="let dr of previewData.dateRanges">
                <span *ngIf="dr.title"><strong>{{dr.title}}:&nbsp;</strong></span>
                <span>
                    {{dr.startDate | date:'mediumDate'}} {{dr.startTime}} -
                    {{dr.endDate | date:'mediumDate'}} {{dr.endTime}}
                </span>
            </li>
        </ul>
    </div>
    <div *ngIf="previewData.resourceType">
        <strong>Resource Type:&nbsp;</strong> <span class="fw-semibold">{{previewData.resourceType}}</span>
    </div>
    <div *ngIf="previewData.removalOption">
        <strong>Resource Deletion Policy:&nbsp;</strong> <span class="fw-semibold">{{previewData.removalOption | titlecase}}</span>
    </div>
    <div *ngIf="previewData.removalDateTime">
        <strong>Scheduled Removal Date:&nbsp;</strong> <span class="fw-semibold">{{previewData.removalDateTime | date:'medium'}}</span>
    </div> -->
    <!-- <div *ngIf="previewData.vmControls">
        <strong>VM Controls:</strong> <span class="fw-semibold">{{previewData.vmControls | json}}</span>
    </div>
    <div *ngIf="previewData.cloudDBControls">
        <strong>Cloud DB Controls:</strong> <span class="fw-semibold">{{previewData.cloudDBControls | json}}</span>
    </div>
    <div *ngIf="previewData.appServiceControls">
        <strong>App Service Controls:</strong> <span class="fw-semibold">{{previewData.appServiceControls | json}}</span>
    </div>
    <div *ngIf="previewData.userAccountControls">
        <strong>User Account Controls:</strong> <span class="fw-semibold">{{previewData.userAccountControls | json}}</span>
    </div> -->
</div>